import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { GatewayChargePointModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-charge-point.model';
import { formatDate } from '@delmonicos/shared-sdk/libs/cpms/src/clients/utils/formatters/format-date';
import { CellContext } from '@tanstack/react-table';

import i18n from '@app/core/locale/i18n';

export interface ChargePointListLastRecordedActivityCellProps
  extends CellContext<
    GatewayChargePointModel,
    GatewayChargePointModel['lastRecordedActivityDate']
  > {}

export const ChargePointListLastRecordedActivityCell = (
  props: ChargePointListLastRecordedActivityCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { getValue } = props;

  // RENDER ////////////////////////////////////////////////////////////////////

  const value = getValue();

  return <Text truncate>{value ? formatDate(value, i18n) : '-'}</Text>;
};
